module.exports = __webpack_public_path__ + "deaffb050b2e0ddcf5b7deaf6a043539.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/cancel_onwhite_24.svg
// module id = 1262
// module chunks = 65